import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { AH_BORDER, AH_MUTED, AH_TEXT, AH_TRACK, AH_WHITE, cardShellSx } from "../theme";

const CARDS = [
  {
    key: "inProgress",
    title: "Assessments in-progress",
    icon: ShowChartIcon,
    tip: "Total assessments in progress. Does not include Drafts",
  },
  {
    key: "approaching",
    title: "Approaching Completion",
    icon: AccessTimeIcon,
    tip: "In-progress assessments whose target date is within 14 days. Overdue assessments are included.",
  },
  {
    key: "stale",
    title: "Inactive Assessments",
    icon: WarningAmberIcon,
    tip: "In-Progress assessments with no activity in the last 14 days. Drafts are not included.",
    warn: true,
  },
];

const SummaryCards = ({ counts }) => (
  <Box sx={{ mb: 2.5 }}>
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.06em",
        color: AH_MUTED,
        textTransform: "uppercase",
        mb: 1.25,
      }}
    >
      Executive Summary
    </Typography>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" },
        gap: 1.5,
      }}
    >
      {CARDS.map((card) => {
        const Icon = card.icon;
        return (
          <Box
            key={card.key}
            sx={{
              ...cardShellSx,
              position: "relative",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              p: 2,
              pr: 4,
              minHeight: 88,
              height: "100%",
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                backgroundColor: card.warn ? "#fff7ed" : AH_TRACK,
                color: card.warn ? "#c2410c" : AH_TEXT,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon sx={{ fontSize: 22 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: "1.75rem",
                  fontWeight: 700,
                  color: AH_TEXT,
                  lineHeight: 1,
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {counts[card.key] == null ? "—" : counts[card.key]}
              </Typography>
              <Typography
                sx={{
                  mt: 0.5,
                  fontSize: "0.8125rem",
                  fontWeight: 600,
                  color: AH_TEXT,
                  lineHeight: 1.35,
                }}
              >
                {card.title}
              </Typography>
            </Box>
            <Tooltip title={card.tip} placement="top">
              <Box
                component="span"
                sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  border: `1px solid ${AH_BORDER}`,
                  color: AH_MUTED,
                  fontSize: 10,
                  fontWeight: 700,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "default",
                  backgroundColor: AH_WHITE,
                }}
              >
                i
              </Box>
            </Tooltip>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default SummaryCards;
